import { Search } from "lucide-react";

import { IgTextField } from "@intelligems/ig-theme";
import { useTheme } from "@mui/material";
import Box from "@mui/material/Box";
import InputAdornment from "@mui/material/InputAdornment";

import { useDispatch, useSelector } from "@src/store";
import {
  VivIdeasAction,
  VivIdeasSelector,
} from "@src/store/slices/experienceBuilder/ideas";

/** Free-text filter over the catalog; the query also drives the empty copy. */
export const IdeaLibrarySearch = () => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const query = useSelector(VivIdeasSelector.getQuery);
  const textPlaceholder = theme.palette.text.placeholder;

  return (
    <Box sx={{ pt: 4, pb: 3, px: 3 }}>
      <IgTextField
        fullWidth
        size="extraSmall"
        value={query}
        placeholder="Search all ideas"
        onChange={(e) => dispatch(VivIdeasAction.setQuery(e.target.value))}
        slotProps={{
          input: {
            startAdornment: (
              <InputAdornment position="start">
                <Search size={16} color={textPlaceholder} />
              </InputAdornment>
            ),
          },
        }}
        sx={{
          "& .MuiOutlinedInput-input::placeholder": {
            color: textPlaceholder,
            opacity: 1,
          },
        }}
      />
    </Box>
  );
};
